import { GET } from "./_config";

export const getContactListApi = async (query: string) =>
  await GET(`/super-admin/contact?${query || ""}`, true);
